module.exports = __webpack_public_path__ + "img/log-manager.d0a397bd.png";